'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');
var ManageCatalogsList = require('../partials/manage-catalogs-list');
var Html = require('base/Colido.Html');
var Awesomplete = require('vendor/awesomplete');

var template = require('../../templates/layout/manage-catalogs.hbs');

var ManageCatalogsLayout = LayoutView.extend({
    template: template,

    className: 'settings settings-manage-catalogs',

    regions: {
        catalogsRegion: '.catalogs-region',
    },

    ui: {
        catalogFormSection: '.create-form-section',
        catalogForm: 'form.add-catalog',
        catalogFormName: '[name="catalog-name"]',
        catalogFormType: '[name="catalog-type"]',
        catalogFormSubtype: '[name="catalog-subtype"]',
        catalogFormAddSampleData: '[name="add-sample-data"]',
        catalogFormSubmit: '[type="submit"]',
        buttonShowCreateForm: '[data-action="show-create-form"]',
        buttonHideCreateForm: '[data-action="hide-create-form"]',
    },

    events: {
        'submit @ui.catalogForm': 'addCatalog',
        'click @ui.buttonShowCreateForm': 'showCreateForm',
        'click @ui.buttonHideCreateForm': 'hideCreateForm',
        'input @ui.catalogFormName': 'checkSubmitButton',
        'change @ui.catalogFormType': 'changeCatalogType',
        //awesomeplete
        //'keyup @ui.catalogFormSubtype': 'checkSubtypeStringLive',
        //'change @ui.catalogFormSubtype': 'checkSubtypeString',
        //'blur @ui.catalogFormSubtype': 'checkSubtypeString',
        //'input @ui.catalogFormSubtype': 'onInputSubtypeField',
        //'awesomplete-selectcomplete @ui.catalogFormSubtype': 'onAwesompleteSelectComplete',
    },

    /**
     * Reference to awesomplete
     * @type {Awesomplete}
     */
    awesomplete: null,

    /**
     * Internal cache
     * @type {Object}
     */
    awesompleteCache: {},

    onRender: function() {
        this.hideCreateForm();

        this.catalogsRegion.show(new ManageCatalogsList({
            collection: this.collection,
        }));

        // Render select fields
        this.renderSelectOptions(
            this.ui.catalogFormSubtype,
            App.radio().request('subtypes:collection'),
            'key',
            'label',
            function(option) {
                return false;
            }.bind(this)
        );
    },

    onAttach: function() {
        // Init awesomplete
        this.awesomplete = new Awesomplete(this.ui.catalogFormSubtype[0], {
            minChars: 1,
            maxItems: 6,
            list: [],
        });

        // Add small class
        this.$('.awesomplete').addClass('awesomplete--small');
    },

    showCreateForm: function() {
        this.ui.catalogFormSection.attr('data-mode', 'edit');
        this.ui.catalogFormName.focus();
    },

    hideCreateForm: function() {
        this.ui.catalogFormSection.attr('data-mode', 'view');
    },

    checkSubmitButton: function() {
        var hasName = this.ui.catalogFormName.val().trim();

        this.ui.catalogFormSubmit.prop('disabled', !hasName);
    },

    addCatalog: function(event) {
        event ? event.preventDefault() : null;

        var name = this.ui.catalogFormName.val().trim();
        var type = this.ui.catalogFormType.val();
        var subtype = this.ui.catalogFormSubtype.val() ? this.ui.catalogFormSubtype.val().trim() : '';

        this.model.save({
            name: name,
            type: type,
            subtype: subtype,
            addSampleData: this.ui.catalogFormAddSampleData.is(':checked'),
        }, {
            success: function(model) {
                model.initialize(); //call initialize to re init child models with proper id
                this.collection.add(model);

                App.router.navigate('/catalogs/' + model.id, {trigger: true});

                Messenger().success({
                    message: App.t('settings::catalogs:create:messages-success', {catalogName: model.get('name')}),
                    hideAfter: 0,
                });
            }.bind(this),

            error: function() {
                this.ui.catalogFormSection.attr('data-mode', 'edit');
                Messenger().error({
                    message: App.t('settings::catalogs:create:messages-error'),
                });
            }.bind(this),
        });

        this.ui.catalogFormSection.attr('data-mode', 'submit');
    },

    changeCatalogType: function() {
        if (this.ui.catalogFormType.val() == 'generic') {
            this.ui.catalogFormSubtype.removeAttr('disabled');
            this.ui.catalogFormAddSampleData.attr('disabled', 'true');
        } else if (this.ui.catalogFormType.val() == 'bills') {
            this.ui.catalogFormSubtype.attr('disabled', 'true');
            this.ui.catalogFormSubtype.val('');
            this.ui.catalogFormAddSampleData.attr('disabled', 'true');
        } else {
            this.ui.catalogFormSubtype.attr('disabled', 'true');
            this.ui.catalogFormSubtype.val('');
            this.ui.catalogFormAddSampleData.removeAttr('disabled');
        }
    },

    /**
     * Checks the subtype string on keyup event
     * @param {object} event The keyup event
     */
    checkSubtypeStringLive: function(event) {
        // Do not run, when arrow key is pressed
        if (!_.contains([
                App.keys.UPARROW,
                App.keys.LEFTARROW,
                App.keys.RIGHTARROW,
                App.keys.DOWNARROW,
            ], event.which)
        ) {
            // Call autocompleter
            if (event.which !== App.keys.RETURN) {
                this.onInputSubtypeField(event);
            }

            // Get proper values
            var textarea = $(event.currentTarget);
            var val      = this.ui.catalogFormSubtype.val().replace(/\r/gm, '');

            // Format, if we have comma or return
            if (_.contains([App.keys.RETURN, App.keys.COMMA, App.keys.COMMA_SECONDARY], event.which)) {
                var caretPosition = Html.getCaretPosition(textarea[0]);

                // We have a comma
                if (event.which === App.keys.COMMA || event.which === App.keys.COMMA_SECONDARY) {
                    var start = val.substr(0, caretPosition);
                    var end   = val.substr(caretPosition, val.length - caretPosition);

                    textarea.val(start + '\n' + end);
                    Html.setCaretPosition(textarea[0], caretPosition + 1);
                }

                // We have a return
                if (event.which === App.keys.RETURN) {
                    if (val.substr(caretPosition - 1, 1) === '\n') {
                        var start = val.substr(0, caretPosition - 1);
                        var end   = val.substr(caretPosition - 1, val.length - caretPosition - 1);

                        var insertComma = start.substr(-1) !== ',';

                        if (end.length == 0) {
                            textarea.val(start + (insertComma ? ',\n' : '\n') + end);
                        } else {
                            textarea.val(start + (insertComma ? ',' : '') + end);
                            Html.setCaretPosition(textarea[0], caretPosition + (insertComma ? 1 : 0));
                        }
                    }
                }
            }

            // Resize textarea
            this.fixTextareaSize(this.ui.catalogFormSubtype);
        }
    },

    /**
     * Checks the locality string, when something has changed
     * @param {object} event The change vent
     */
    checkSubtypeString: function(event) {
        var $curTarget = $(event.currentTarget);
        this.setProperLocalityValue($curTarget);
    },

    /**
     * Is triggered, when the user inputs something into the locality field
     * @param {object} event The input event
     */
    onInputSubtypeField: function(event) {
        // Get value without breaks
        var val = this.ui.catalogFormSubtype.val().replace(/[\r\n]+/gm, ' ').replace(/[\s]{2,}/g, ' ');

        // Process response from api or cache
        if (this.awesompleteCache[val]) {
            this.processAutocompleteResponse(this.awesompleteCache[val]);
        } else {
            var request = $.getJSON(App.getApiUrl('/catalogs/subtypes/' + val));
            request.done(function(response) {
                this.awesompleteCache[val] = response;
                this.processAutocompleteResponse(response);
            }.bind(this));
        }
    },

    /**
     * Processes the response from API or cache
     * @param {object} response The response object, containing autocomplete items
     */
    processAutocompleteResponse: function(response) {
        if (this.awesomplete) {
            this.awesomplete.list = _.pluck(_.values(response), 'displayPath');
            this.awesomplete.evaluate();
        }
    },

    /**
     * Is triggered, when the user selects a value from autocomplete
     * @param {object} event The select complete event from awesomplete
     */
    onAwesompleteSelectComplete: function(event) {
        this.setProperLocalityValue(this.ui.catalogFormSubtype);
        if (this.awesomplete) {
            this.awesomplete.close();
        }
    },

    /**
     * Sets the proper value for the locality input
     * @param {object}  textarea The jquery textarea object
     * @param {string=} value    The value to set
     */
    setProperLocalityValue: function(textarea, value) {
        value = value || textarea.val();

        textarea.val(this.getFormattedValue(value));
        this.fixTextareaSize(textarea);
    },

    /**
     * Returns the formatted string for the locality
     * @param {string} string The input string
     * @returns {string} The formattes string
     */
    getFormattedValue: function(string) {
        var formattedTokens = [];

        var tokens = string.trim()
            .replace(/,$/, '') // Remove last comma
            .replace(/\r/gm, '') // Remove carriage returns
            .replace(/,{2,}/gm, ',') // Remove double commas
            .split(',');

        _.each(tokens, function(token) {
            token = token.trim();

            if (token.length) {
                formattedTokens.push(token);
            }
        });

        return formattedTokens.join(',\n').trim();
    },
});

module.exports = ManageCatalogsLayout;